import React from 'react';
import PropTypes from 'prop-types';

const CustomHtags = ({ type, tagType, subType, children, style, ...props }) => {
    // Define default styles for different types and subtypes
    const styles = {
        desktop: {
            header: {
                h1: {
                    fontFamily: 'Mulish',
                    fontWeight: 700,
                    fontSize: '32px',
                    lineHeight: '36px',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                },
                h2: {
                    fontFamily: 'Mulish',
                    fontWeight: 600,
                    fontSize: '28px',
                    lineHeight: '32px',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                },
                h3: {
                    fontFamily: 'Mulish',
                    fontWeight: 700,
                    fontSize: '32px',
                    lineHeight: '36px',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                },
            },
            paragraph: {
                p: {
                    fontFamily: 'Mulish',
                    fontWeight: 400,
                    fontSize: '16px',
                    lineHeight: '24px',
                    letterSpacing: '0%',
                },
            },
        },
        tablet: {
            header: {
                h1: {
                    fontFamily: 'Mulish',
                    fontWeight: 700,
                    fontSize: '28px',
                    lineHeight: '32px',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                },
                h2: {
                    fontFamily: 'Mulish',
                    fontWeight: 600,
                    fontSize: '24px',
                    lineHeight: '28px',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                },
            },
            paragraph: {
                p: {
                    fontFamily: 'Mulish',
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: '20px',
                    letterSpacing: '0%',
                },
            },
        },
        mobile: {
            header: {
                h1: {
                    fontFamily: 'Mulish',
                    fontWeight: 700,
                    fontSize: '24px',
                    lineHeight: '28px',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                },
                h2: {
                    fontFamily: 'Mulish',
                    fontWeight: 600,
                    fontSize: '20px',
                    lineHeight: '24px',
                    letterSpacing: '0%',
                    verticalAlign: 'middle',
                },
            },
            paragraph: {
                p: {
                    fontFamily: 'Mulish',
                    fontWeight: 400,
                    fontSize: '12px',
                    lineHeight: '18px',
                    letterSpacing: '0%',
                },
            },
        },
    };

    // Get the appropriate style based on type, tagType, and subType
    const defaultStyle = styles[type]?.[tagType]?.[subType] || {};

    // Dynamically render the tag based on subType
    const Tag = subType || 'div';

    return (
        <Tag style={{ ...defaultStyle, ...style }} {...props}>
            {children}
        </Tag>
    );
};

CustomHtags.propTypes = {
    type: PropTypes.oneOf(['mobile', 'tablet', 'desktop']).isRequired,
    tagType: PropTypes.oneOf(['header', 'paragraph']).isRequired,
    subType: PropTypes.string.isRequired, // e.g., 'h1', 'h2', 'p'
    children: PropTypes.node.isRequired,
    style: PropTypes.object,
};

export default CustomHtags;